export default __webpack_public_path__ + "static/media/logo_dark.5c5de091.png";